import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';

export const StyledRewardsLogo = LoyaltyRewardsLogo.withConfig({
  marginTop: '$0',
  marginX: 'auto',
  marginBottom: '$8',
  paddingY: '$0',
  paddingX: '$6',
  width: 'full',
  height: '$16',
});
